import React from 'react';

import { Separator, TopNav } from "../../components"
import { Search } from "../../views"
import { Categories } from "./index.jsx"

const Header = ({ className, withCategories, withCart, withSearch, withSearchFilters, user, topNavItems }) => {
    const showTopNav = !withCategories && topNavItems;

    return (
        <>
            <header className={className}>
                <div className={`${showTopNav ? '' : 'd-none'} d-xl-block`}>
                    { withCategories && <Categories />}
                    { showTopNav && <TopNav items={topNavItems } />}

                    <Separator noMargin className={`mb-0 d-none d-md-block ${withCategories && 'mt-3'}`} />
                </div>

                { withSearch && (
                    <>
                        <Search withFilters={withSearchFilters} />
                        <Separator noMargin className="header-separator mb-0 d-none d-md-block" />
                    </>
                )}
            </header>
        </>
    )
}

export default Header
